import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { AnalyticsEcommerceHelpersOysho } from '../helpers/brand-analytics-ecommerce.helpers.oy';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';
import { AnalyticsOyshoEventsTransformer } from '../helpers/brand-analytics-events.transformer.oy';
import { AnalyticsHelpersOysho } from '../helpers/brand-analytics.helpers.oy';
import { getDefaultAnalytics } from '../helpers/events.helper';

export const ShopCartEvents: AnalyticsBrandSettings = {

  cestaWishlistAnadirProductWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
        partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: true });
    }
    const label = `${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'wishlist', 'anadir_producto_wishlist', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['16', '17', '198', '20', '71'];
    if (isDefined(helpers)) {
        settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceRemove(componentData, context);
    return settingsGTM;
  },

  cestaWishlistAnadirProductWishlistCesta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
        partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: true });
    }
    const label = `${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'wishlist', 'anadir_producto_wishlist_cesta', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '48', '58', '70', '98'];
    if (isDefined(helpers)) {
        settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceAdd(componentData, context);
    return settingsGTM;
  },

  cestaWishlistAnadirTodoCesta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, context } = data;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'wishlist', 'anadir_todo_cesta');
    const settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceAdd(componentData, context);
    return settingsGTM;
  },

  cestaWishlistCompartirWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'wishlist', 'compartir_wishlist');
    const settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    return settingsGTM;
  },

  cestaCheckoutEliminar(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
        partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: true });
    }
    const label = `${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'checkout', 'eliminar', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '31', '32', '51', '52', '53'];
    if (isDefined(helpers)) {
        settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceRemove(componentData, context);
    return settingsGTM;
  },

  cestaCheckoutEliminarProductoWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
        partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const label = `${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'wishlist', 'eliminar_producto_wishlist', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20'];
    if (isDefined(helpers)) {
        settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  cestaCheckoutDecrementar(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
        partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: true });
    }
    const label = `${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'checkout', 'decrementar', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '31', '32', '51', '52', '53'];
    if (isDefined(helpers)) {
        settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceRemove(componentData, context);
    return settingsGTM;
  },

  cestaCheckoutIncrementar(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
        partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: true });
    }
    const label = `${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'checkout', 'incrementar', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '31', '32', '51', '52', '53'];
    if (isDefined(helpers)) {
        settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceAdd(componentData, context);
    return settingsGTM;
  },

  cestaCheckoutSeleccionarColor(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
        partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const label = `${partnumber}-color_${product?.color}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'checkout', 'seleccionar_color', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '48'];
    if (isDefined(helpers)) {
        settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceAdd(componentData, context);
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceRemove(componentData, context);
    return settingsGTM;
  },

  cestaCheckoutSeleccionarTalla(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
        partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const label = `${partnumber}-talla_${product?.sizeCode}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'checkout', 'seleccionar_color', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '58'];
    if (isDefined(helpers)) {
        settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceAdd(componentData, context);
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceRemove(componentData, context);
    return settingsGTM;
  },

  cestaCheckoutSeleccionarLargo(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
        partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const label = `${partnumber}-largo_${product?.sizeLong}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'checkout', 'seleccionar_largo', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '14'];
    if (isDefined(helpers)) {
        settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  cestaCheckoutSiguientePaso(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'checkout', 'siguiente_paso');
    const settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    return settingsGTM;
  },

  cestaCheckoutVolverAtras(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'checkout', 'volver_atras');
    const settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    return settingsGTM;
  },

  cestaCheckoutVerCodigosPromocionales(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'checkout', 'ver_codigos_promocionales');
    const settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    return settingsGTM;
  },

  cestaCheckoutValidadCodigoOk(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;

    // Extra info is the promotion code in this case
    const label = `${componentData.extraInfo}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'checkout', 'validar_codigo_ok', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['41'];
    if (isDefined(helpers)) {
        settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  cestaCheckoutEliminarCodigo(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;

    // Extra info is the promotion code in this case
    const label = `${componentData.extraInfo}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'checkout', 'eliminar_codigo', label);
    const settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    return settingsGTM;
  },

  cestaCheckoutVerOpcionesRegalo(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'checkout', 'ver_opciones_regalo');
    const settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    return settingsGTM;
  },

  cestaCheckoutVerProducto(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
        partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const label = `${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'checkout', 'ver_producto', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['100', '101', '117', '15', '20', '46', '47', '99'];
    if (isDefined(helpers)) {
        settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  wishlistCatalogoVerProducto(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
        partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: false });
    }
    const label = `${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'wishlist', 'catalogo', 'ver_producto', label);
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['100', '101', '117', '15', '20', '46', '47', '99'];
    if (isDefined(helpers)) {
        settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  cestaCheckoutModificarCesta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'cesta', 'checkout', 'modificar_cesta');
    const settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    return settingsGTM;
  },

}
